/**
 * Verifies that passed value is defined. Intended to use as a TS guard
 * @example
 * const values = [1, 2, undefined, 3, null].filter(isDefined) // typeof values[number] => number
 */
export default function isDefined<T>(x: T | undefined | null): x is T {
  return x !== undefined && x !== null
}
